<template>
    <section class="deep-dive">
        <h2 class="deep-dive__title">{{ sectionTitle }}</h2>

        <div class="deep-dive__grid">
            <template v-for="item in displayItems">
                <a v-if="item.type === 'article'" :key="item.key" class="deep-dive__card"
                    :href="getPageUrl(`/blog/${item.data.slug || item.data.id}`)">
                    <div class="deep-dive__badge">
                        <span>✓</span>
                        <em>Blog</em>
                    </div>
                    <h3 class="deep-dive__card-title">{{ item.data.title }}</h3>
                    <div class="deep-dive__card-footer">
                        <span class="deep-dive__date">{{ item.data.date }}</span>
                        <span class="deep-dive__arrow">→</span>
                    </div>
                </a>
                <div v-else :key="item.key" class="deep-dive__inline-ad">
                    <AdComponent class="ad-width-100" :ads="item.data" :showDebug="showAdDebug" :forceDebug="true"
                        :debugLabel="item.label" :debugPosition="item.position" />
                </div>
            </template>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'
import AdComponent from '@/pages/components/AdComponent.vue'
import adMixin from '@/mixin/adMixin.js'

export default {
    name: 'HomeDeepDive',
    components: {
        AdComponent
    },
    mixins: [adMixin],
    props: {
        pcInlineAd: {
            type: Object,
            default: () => ({})
        },
        mobileInlineAds: {
            type: Object,
            default: () => ({})
        },
        showAdDebug: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['livableCityData', 'deviceType']),
        sectionTitle() {
            return 'The Deep Dive'
        },
        isMobile() {
            return this.deviceType === 'mobile'
        },
        articles() {
            return (this.livableCityData.blogs || []).slice(0, 6)
        },
        displayItems() {
            const items = []
            this.articles.forEach((article, index) => {
                const cardNumber = index + 1
                items.push({
                    type: 'article',
                    key: `article-${article.id}`,
                    data: article
                })

                if (this.isMobile) {
                    return
                }

                if (cardNumber === 3 && this.pcInlineAd && Object.keys(this.pcInlineAd).length) {
                    items.push(this.buildAdItem('pc-middle', this.pcInlineAd, 'home_5', 'Blog 中间（仅PC）'))
                }
            })
            return items
        }
    },
    methods: {
        buildAdItem(key, adData, label, position) {
            return {
                type: 'ad',
                key: `ad-${key}`,
                data: adData,
                label,
                position
            }
        },
        getPageUrl(path) {
            if (this.$route.params.channel) {
                return `/${this.$route.params.channel}${path}`;
            }
            return path;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.deep-dive {
    width: 100%;
    box-sizing: border-box;

    &__title {
        margin: 0 0 rem(40);
        text-align: center;
        font-family: $font-family-serif;
        font-size: rem(28);
        font-weight: 700;
        line-height: rem(36);
        color: #000;
    }

    &__grid {
        display: grid;
        gap: rem(24);
    }

    &__inline-ad {
        width: 100%;
    }

    &__card {
        border-radius: rem(24);
        border: 1px solid $color-border;
        padding: rem(24);
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0) 100%);
        display: flex;
        flex-direction: column;
        gap: rem(24);
        transition: transform 0.25s ease;
        cursor: pointer;
        text-decoration: none;
        color: inherit;

        &:hover {
            transform: translateY(rem(-6));
        }
    }

    &__badge {
        height: rem(32);
        display: inline-flex;
        align-items: center;
        gap: rem(6);
        padding: 0 rem(12);
        border-radius: rem(100);
        background: $color-primary;
        width: fit-content;

        span {
            font-size: rem(12);
            line-height: rem(12);
        }

        em {
            font-family: $font-family-serif;
            font-size: rem(16);
            font-style: normal;
            font-weight: 500;
            line-height: rem(16);
            text-transform: uppercase;
        }
    }

    &__card-title {
        margin: 0;
        font-family: $font-family-serif;
        font-size: rem(20);
        font-weight: 500;
        line-height: rem(28);
        color: #000;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    &__card-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    &__date {
        font-family: $font-family-serif;
        font-size: rem(16);
        font-weight: 300;
        line-height: rem(16);
        color: #000;
    }

    &__arrow {
        width: rem(32);
        height: rem(32);
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: #000;
        color: $color-primary;
        text-decoration: none;
        font-size: rem(16);
        line-height: rem(16);
    }
}

.detect_deviece_pc,
.detect_deviece_desktop {
    .deep-dive {
        padding: rem(100) rem(180);

        &__grid {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }

        &__inline-ad {
            grid-column: 1 / -1;
        }
    }
}

.detect_deviece_mobile {
    .deep-dive {
        padding: rem(100) rem(16);

        &__grid {
            grid-template-columns: 1fr;
            gap: rem(12);
        }
    }
}
</style>
